import React from 'react';

const SvgActions51 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 20 19" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M20 5.5A5.5 5.5 0 0 0 14.5 0 6.36 6.36 0 0 0 10 2.07 6.36 6.36 0 0 0 5.5 0 5.5 5.5 0 0 0 0 5.5C0 9.42 4.75 13.75 7 16l2.28 2.28c.14.14.331.22.53.22h.38a.75.75 0 0 0 .53-.22L13 16c2.25-2.25 7-6.58 7-10.5z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgActions51 svgRef={ref} {...props} />);
export default ForwardRef;
